module.exports = __webpack_public_path__ + "img/default.e5d94406.png";